<div class="page-container">
  <app-toolbar [title]="'COMMON.CALLS' | translate"></app-toolbar>

  <div class="page">
    <div class="panel">
      <div class="table-controls">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>{{ 'ADMIN.FILTERS.CALL_NAME' | translate }}</mat-label>
          <input
            matInput
            [ngModel]="nameQuery$ | async"
            (ngModelChange)="nameQueryUpdate$.next($event)"
            [placeholder]="'ADMIN.FILTERS.CALL_NAME' | translate"
          />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        @if (dateRange$ | async; as dateRange) {
          <app-date-range-picker
            class="date-range"
            [startDate]="dateRange.startDate"
            [endDate]="dateRange.endDate"
            (rangeChange)="updateDateRange($event)"
          ></app-date-range-picker>
        }

        <mat-slide-toggle [checked]="(includeAllStatuses$ | async) ?? false" (change)="toggleIncludeAllStatuses($event.checked)" color="primary">
          {{ 'ADMIN.CALLS.SHOW_ALL' | translate }}
        </mat-slide-toggle>
      </div>

      @if (calls$ | async; as result) {
        @if (result.isLoading) {
          <app-spinner></app-spinner>
        } @else if (result.isError) {
          <p>{{ 'COMMON.ERROR_LOADING_DATA' | translate }}</p>
        } @else if (result.data; as calls) {
          <app-paginated-table
            [data]="calls.list"
            [total]="calls.total"
            [defaultPageSize]="defaultPageSize"
            [page]="(page$ | async) ?? 0"
            [columns]="columnDefinitions"
            [actions]="actions"
            [csvDownloadEnabled]="false"
            [csvFilename]="'calls'"
            [stickyActionsColumn]="true"
            [timezone]="'local'"
            (refetch)="handleListOptionsChange($event)"
          ></app-paginated-table>
        }
      }
    </div>
  </div>
</div>
